/**
 * company - letterhead data for the "Organization Structure" export.
 *
 * Build-time config, same pattern as any other `REACT_APP_*` value: CRA
 * inlines these into the bundle at `npm run build` time. Never put a secret
 * here (see the client/.env note in CLAUDE.md).
 */
const company = {
  name: process.env.REACT_APP_COMPANY_NAME || 'ByteCorp',
  tagline: process.env.REACT_APP_COMPANY_TAGLINE || 'Building the future.',
  email: process.env.REACT_APP_COMPANY_EMAIL || 'info@bytecorp.io',
  address: process.env.REACT_APP_COMPANY_ADDRESS || '2nd Floor, A-352 Block 15, Gulistan-e-Jauhar, Karachi',
  phone: process.env.REACT_APP_COMPANY_PHONE || '021-34012585',
  website: process.env.REACT_APP_COMPANY_WEBSITE || 'www.bytecorp.io',
  linkedin: process.env.REACT_APP_COMPANY_LINKEDIN || 'bytecorp',
};

export default company;
